module.exports = __webpack_public_path__ + "components/instagram-button/static/instagram-a274e39ec40866e92cca19202b55f9dc.svg";